import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { useAuthStore } from '../../auth/stores/authStore';
import { api } from '../../../shared/api/billdaApi';

export const platformKeys = {
  all: ['platform'] as const,
  organisations: (searchTerm?: string) =>
    [...platformKeys.all, 'organisations', searchTerm ?? ''] as const,
  organisation: (orgId: string) =>
    [...platformKeys.all, 'organisation', orgId] as const,
};

export function usePlatformOrganisations(searchTerm?: string) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: platformKeys.organisations(searchTerm),
    queryFn: async ({ signal }) => {
      const result = unwrap(
        await api.legacy.GET('/api/v1/platform/organisations', {
          params: { query: { searchTerm } },
          signal,
        })
      );
      return result?.organisations ?? [];
    },
    placeholderData: previousData => previousData,
    enabled: isAuthenticated,
  });
}
